export default "__VITE_ASSET__dc33b817__"